// src/api/log.js
import axios from 'axios';
/**
 * 生成 时间戳 + 128位随机字符串 的唯一标识
 * @returns {string} 格式：17位时间戳 + 128位随机字符（字母+数字）
 */
function generateTimestampWithRandomStr () {
    // 1. 获取当前毫秒级时间戳（13位），也可改用秒级（10位）：Math.floor(Date.now() / 1000)
    const timestamp = Date.now().toString();

    // 2. 生成128位随机字符串（字母+数字组合，避免纯数字/纯字母）
    const randomStr = generateRandomString(128);

    // 3. 拼接返回
    return timestamp + randomStr;
}

/**
 * 辅助函数：生成指定长度的随机字符串（字母+数字）
 * @param {number} length 字符串长度
 * @returns {string} 随机字符串
 */
function generateRandomString (length) {
    // 定义随机字符池（大小写字母+数字，避免易混淆字符：0/O、1/l）
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
    let result = '';
    const charsLength = chars.length;

    // 循环生成指定长度的随机字符
    for (let i = 0; i < length; i++) {
        // 随机取字符池中的字符（Math.random() 生成0-1的随机数）
        const randomIndex = Math.floor(Math.random() * charsLength);
        result += chars.charAt(randomIndex);
    }

    return result;
}


const uniqueId = generateTimestampWithRandomStr();

// 封装日志上报接口
export function reportLog (name) {
    return axios({
        url: 'https://nmdc.cn/api/services/nmdc/api/create/logs',
        // withCredentials: true,
        method: 'post', // 接口大概率是post请求，若为get可修改
        data: {
            'websiteName': name,
            'url': window.location.href,
            sessionID: uniqueId
        }, // 若为get请求则改为 params: data
        // 可选：添加请求头、超时时间等配置
        timeout: 5000,
        headers: {
            'Content-Type': 'application/json' // 根据接口要求配置
        }
    }).then(res => {
        console.log(res.headers);
    }).catch(err => {
        // 接口请求失败不阻塞业务，仅打印日志
        console.warn('日志上报接口请求失败：', err);
    });
}



// WEBPACK FOOTER //
// ./src/js/log.js